import { AxiosPromise } from 'axios';
import axios from 'axios';
import {
  IGeneralMessageParams,
  IGeneralMessageReq,
  IGetGeneralMessage,
  IGetMessageDetails,
  IGetMessageReSend,
  IGetMessages,
  IGetStudentMessage,
  IGetStudents,
  IGetTextMessages,
  IMessageDetailReq,
  ISendMessageReq,
  ISentMessageReq,
  IStudentMessageReq,
  IStudentReq,
  ITextMessageParams,
  ITextMessageReq,
} from '../models/pushMessage.model';
import QueryString from 'qs';

const uri = '/mgmt/push-message';

export const getStudents = (data: IStudentReq): AxiosPromise<IGetStudents> => {
  return axios.post(`${uri}/students`, data);
};

export const getStudentMessages = (
  memberCode: string,
  params: IStudentMessageReq,
): AxiosPromise<IGetStudentMessage> =>
  axios.get(`${uri}/students/${memberCode}`, { params });

export const getMessages = (
  params: ISentMessageReq,
): AxiosPromise<IGetMessages> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}?${qsParams}`);
};

export const sendMessages = (data: ISendMessageReq): AxiosPromise => {
  return axios.post(`${uri}/register-replace`, data);
};

export const sendMultiMessages = (data: ISendMessageReq[]): AxiosPromise => {
  return axios.post(`${uri}/register/multi-number`, JSON.stringify(data), {headers: {
    "Content-Type": "application/json",
  }});
};

export const getMessageDetails = (
  smsSendCode: number,
  params: IMessageDetailReq,
): AxiosPromise<IGetMessageDetails> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/${smsSendCode}?${qsParams}`);
};

export const cancelReservation = (smsSendCode: number): AxiosPromise => {
  return axios.delete(`${uri}/${smsSendCode}`);
};

export const getTextMessages = (
  params: ITextMessageParams,
): AxiosPromise<IGetTextMessages> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/employee?${qsParams}`);
};

export const sendTextMessages = (data: ITextMessageReq): AxiosPromise => {
  return axios.post(`${uri}/employee`, data);
};

export const sendGeneralMessages = (data: IGeneralMessageReq): AxiosPromise => {
  return axios.post(`${uri}/general-register`, data);
};

export const getGeneralMessages = (
  params: IGeneralMessageParams,
): AxiosPromise<IGetGeneralMessage> => {
  const qsParams = QueryString.stringify(params);
  return axios.get(`${uri}/general?${qsParams}`);
};

export const getMessageResend = (
  smsSendCode: number,
): AxiosPromise<IGetMessageReSend> => {
  return axios.get(`${uri}/${smsSendCode}/detail`);
};
